import T from 'i18n-react';

import texts from 'Components/texts.json';
import { FEATURES } from 'Context/FeaturesContext/FeaturesContextConsts';
import type { ListType } from 'Types/listType';
import { LIST_TYPES } from 'Utilities/consts';
import useFeatureToggle from 'Utilities/hooks/useFeatureToggle';

T.setTexts(texts);

interface UseNoSaleMessageProps {
	listType: ListType;
	messageProp?: string;
}

const noShortlistMessage = T.translate('vehicleList.noShortlistMessage');
const newStockSoonMessage = T.translate('vehicleList.newStockSoon');
const binRemovedNewStockSoonMessage = T.translate('vehicleList.binRemovedNewStockSoon');

const useNoSaleMessage = ({ listType, messageProp }: UseNoSaleMessageProps): string => {
	const isRemoveBuyItNowFeatureEnabled = useFeatureToggle(FEATURES.removeBuyItNow);
	const isVehicleListDisabled = useFeatureToggle(FEATURES.showDownloadCSVButtonOutsideList);

	if (isVehicleListDisabled) {
		return 'While we are resolving the ongoing issues with the vehicle list, please use the CSV download on the top right corner of the page to view and bid on vehicles';
	}

	const isShortlist = listType === LIST_TYPES.shortlist;
	const conditionalNewStockSoonMessage = isRemoveBuyItNowFeatureEnabled
		? binRemovedNewStockSoonMessage
		: newStockSoonMessage;
	const message = isShortlist ? noShortlistMessage : conditionalNewStockSoonMessage;

	return messageProp || `${message}`;
};

export default useNoSaleMessage;
